import { useTranslation } from "react-i18next";
import { useOperationsMap } from "../OperationsMapProvider";
import { Box, Button, MenuItem, Select } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useCallback } from "react";
import { setLocalStorageValue } from "../../../../common/helpers";
import { Add as AddIcon } from "@mui/icons-material";
import { useStation } from "../../../../providers/StationProvider";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      padding: theme.spacing(1.5),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.divider}`,
      marginLeft: `calc(var(--scrollbar-width) * -1)`,
      marginRight: `calc(var(--scrollbar-width) * -1)`,
      display: "flex",
      justifyContent: "space-between"
    }
  })
);

export default function ActiveTasksToolbar() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { createMissionDraft } = useStation();
  const { orderTasksBy, setOrderTasksBy, operationsMap } = useOperationsMap();

  const onSetOrderTasksBy = useCallback((ev) => { 
    setOrderTasksBy(ev.target.value);
    setLocalStorageValue("operationmap_order_tasks_by", ev.target.value);
  }, [operationsMap]);

  return (
    <Box className={classes.root}>

      <Button startIcon={<AddIcon />} variant="contained" color="neutral" size="small" onClick={createMissionDraft}>
        {t("operationsMap:createMission")}
      </Button>

      <Select size="small" variant="standard" disableUnderline value={orderTasksBy} onChange={onSetOrderTasksBy}>
        <MenuItem value="new">{t("common:filters:orderBy:new")}</MenuItem>
        <MenuItem value="old">{t("common:filters:orderBy:old")}</MenuItem>
        <MenuItem value="state_asc">{t("common:filters:orderBy:state_asc")}</MenuItem>
        <MenuItem value="state_desc">{t("common:filters:orderBy:state_desc")}</MenuItem>
        <MenuItem value="driver">{t("common:filters:orderBy:driver")}</MenuItem>
        <MenuItem value="eta">{t("common:filters:orderBy:eta")}</MenuItem>
      </Select>

    </Box>
  );
}
